
// export const AddToRecent = (
//     item_id,
//     item_number,
//     item_title,
//     item_brand_name, // 👈 added
//     item_mrp,
//     item_price,
//     item_qty,
//     item_img_url,
//     item_url,
//     item_sup_id,
//     stock_oe
// ) => {

//     var recents = localStorage.getItem('recents')
//         ? JSON.parse(localStorage.getItem('recents'))
//         : [];


//     const recentItem = {
//         item_id: item_id,
//         item_number: item_number,
//         item_title: item_title,
//         item_brand_name: item_brand_name, // 👈 added
//         item_mrp: item_mrp,
//         item_price: item_price,
//         item_qty: item_qty,
//         item_img_url: item_img_url,
//         item_url: item_url,
//         item_sup_id: item_sup_id,
//         stock_oe: stock_oe
//     };

//     if (recents !== "" && recents !== undefined && recents !== null) {

//         const index = recents.findIndex(
//             item => item.item_id === item_id
//         );

//         if (index !== -1) {

//             recents[index].item_qty =
//                 recents[index].item_qty + item_qty;

//             recents[index].stock_oe = stock_oe;

//             // 👇 update brand also
//             recents[index].item_brand_name = item_brand_name;

//             localStorage.setItem(
//                 'recents',
//                 JSON.stringify(recents)
//             );

//             return true;

//         } else {

//             recents.push(recentItem);

//             localStorage.setItem(
//                 'recents',
//                 JSON.stringify(recents)
//             );

//             return true;
//         }

//     } else {

//         recents.push(recentItem);

//         localStorage.setItem(
//             'recents',
//             JSON.stringify(recents)
//         );

//         return true;
//     }
// };


// export const DeleteRecentItem = (index) => {

//     var recents = localStorage.getItem('recents');

//     recents = JSON.parse(recents);

//     recents.splice(index, 1);

//     localStorage.setItem(
//         'recents',
//         JSON.stringify(recents)
//     );

//     return true;
// };


// export const GetRecents = () => {

//     var recents = localStorage.getItem('recents');

//     if (recents === "" || recents === null) {
//         return [];
//     }

//     recents = recents !== ""
//         ? JSON.parse(recents)
//         : [];

//     // 👇 keep only latest 30
//     if (recents.length > 30) {

//         recents = recents.slice(recents.length - 30);

//         localStorage.setItem(
//             'recents',
//             JSON.stringify(recents)
//         );
//     }

//     return recents.reverse();
// };


// ==============================
// ADD TO RECENT
// ==============================

export const AddToRecent = (
    item_id,
    item_number,
    item_title,
    item_brand_name,
    item_mrp,
    item_price,
    item_qty,
    item_img_url,
    item_url,
    item_sup_id,
    stock_oe
) => {

    let recents = localStorage.getItem('recents')
        ? JSON.parse(localStorage.getItem('recents'))
        : [];

    const recentItem = {
        item_id,
        item_number,
        item_title,
        item_brand_name,
        item_mrp,
        item_price,
        item_qty,
        item_img_url,
        item_url,
        item_sup_id,
        stock_oe
    };

    // ✅ duplicate check
    const index = recents.findIndex(item => {

        // stock oe
        if (Number(stock_oe) === 1 || Number(stock_oe) === 2) {

            return (
                item.item_number
                    ?.replace(/[-\s]/g, '')
                    ?.trim()
                    ?.toLowerCase() ===
                item_number
                    ?.replace(/[-\s]/g, '')
                    ?.trim()
                    ?.toLowerCase()
                &&
                item.item_brand_name
                    ?.trim()
                    ?.toLowerCase() ===
                item_brand_name
                    ?.trim()
                    ?.toLowerCase()
            );
        }

        // regular stock
        return (
            item.item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase() ===
            item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase()
            &&
            Number(item.item_sup_id) === Number(item_sup_id)
        );
    });

    // ✅ remove duplicate old item
    if (index !== -1) {
        recents.splice(index, 1);
    }

    // ✅ latest item add
    recents.push(recentItem);

    // ✅ max 30 items
    if (recents.length > 30) {
        recents = recents.slice(recents.length - 30);
    }

    localStorage.setItem(
        'recents',
        JSON.stringify(recents)
    );

    return true;
};


// ==============================
// DELETE RECENT
// ==============================

export const DeleteRecentItem = (index) => {

    let recents = localStorage.getItem('recents');

    recents = JSON.parse(recents);

    recents.splice(index, 1);

    localStorage.setItem(
        'recents',
        JSON.stringify(recents)
    );

    return true;
};


// ==============================
// GET RECENTS
// ==============================

export const GetRecents = () => {

    let recents = localStorage.getItem('recents');

    if (
        recents === "" ||
        recents === null ||
        recents === undefined
    ) {
        return [];
    }

    recents = JSON.parse(recents);

    // ✅ remove duplicates again safety
    const uniqueRecents = [];

    recents.forEach(item => {

        const exists = uniqueRecents.find(existing => {

            // stock oe
            if (
                Number(item.stock_oe) === 1 ||
                Number(item.stock_oe) === 2
            ) {

                return (
                    existing.item_number
                        ?.replace(/[-\s]/g, '')
                        ?.trim()
                        ?.toLowerCase() ===
                    item.item_number
                        ?.replace(/[-\s]/g, '')
                        ?.trim()
                        ?.toLowerCase()
                    &&
                    existing.item_brand_name
                        ?.trim()
                        ?.toLowerCase() ===
                    item.item_brand_name
                        ?.trim()
                        ?.toLowerCase()
                );
            }

            // regular stock
            return (
                existing.item_number
                    ?.replace(/[-\s]/g, '')
                    ?.trim()
                    ?.toLowerCase() ===
                item.item_number
                    ?.replace(/[-\s]/g, '')
                    ?.trim()
                    ?.toLowerCase()
                &&
                Number(existing.item_sup_id) ===
                Number(item.item_sup_id)
            );
        });

        if (!exists) {
            uniqueRecents.push(item);
        }
    });

    // ✅ keep only latest 30
    const latestRecents =
        uniqueRecents.length > 30
            ? uniqueRecents.slice(uniqueRecents.length - 30)
            : uniqueRecents;

    localStorage.setItem(
        'recents',
        JSON.stringify(latestRecents)
    );

    return latestRecents.reverse();
};